// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".unavailable{background:repeating-linear-gradient(-45deg,rgba(96,108,188,.25),rgba(96,109,188,.25) 10px,rgba(70,82,152,.25) 0,rgba(70,82,152,.25) 20px);padding:15px;border-radius:6px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
